/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientServiceSparkModel } from '../../models/patient-service-spark-model';

export interface GetMyServices$Params {
  date?: string;
}

export function GetMyServices(http: HttpClient, rootUrl: string, params?: GetMyServices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientServiceSparkModel>>> {
  const rb = new RequestBuilder(rootUrl, GetMyServices.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientServiceSparkModel>>;
    })
  );
}

GetMyServices.PATH = '/api/Staff/GetMyServices';
